import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn' // 导入中文语言包
import relativeTime from 'dayjs/plugin/relativeTime' // 相对时间插件
import advancedFormat from 'dayjs/plugin/advancedFormat' // 高级格式插件
import customParseFormat from 'dayjs/plugin/customParseFormat' // 自定义格式解析插件
import weekday from 'dayjs/plugin/weekday' // 星期插件
import localeData from 'dayjs/plugin/localeData' // 本地化数据插件

// 使用插件
dayjs.extend(relativeTime)
dayjs.extend(advancedFormat)
dayjs.extend(customParseFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)

// 设置中文为默认语言
dayjs.locale('zh-cn')

/**
 * 日期时间格式化过滤器
 * @param {Date|String|Number} date - 日期
 * @param {String} format - 格式字符串
 * @returns {String} 格式化后的日期字符串
 */
export function dateFormat(date, format = 'YYYY-MM-DD HH:mm:ss') {
  if (!date) return;
  return dayjs(date).format(format)
}

/**
 * 相对时间过滤器
 * @param {Date|String|Number} date - 日期
 * @returns {String} 相对时间字符串
 */
export function relativeTimeFilter(date) {
  return dayjs(date).fromNow()
}

/**
 * 日期时间格式化（简短格式）
 * @param {Date|String|Number} date - 日期
 * @returns {String} 格式化后的日期字符串
 */
export function shortDateTime(date) {
  return dayjs(date).format('MM-DD HH:mm')
}

export default dayjs